import React, { useState, useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
import { LayoutProvider } from '../../context/LayoutContext';

interface PremiumLayoutProps {
  children: React.ReactNode;
  userTier?: string;
}

export const PremiumLayout: React.FC<PremiumLayoutProps> = ({ 
    children, 
  }) => {
  const [isNavVisible, setIsNavVisible] = useState(true);
  const lastScrollY = useRef(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      // Esconder ao rolar para baixo, mostrar ao rolar para cima
      if (currentScrollY > lastScrollY.current && currentScrollY > 100) {
        setIsNavVisible(false);
      } else {
        setIsNavVisible(true);
      }
      lastScrollY.current = currentScrollY;
    };
    
    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <LayoutProvider value={{ isNavVisible }}>
      <div className="min-h-screen bg-gradient-to-br from-slate-50 via-violet-50 to-purple-50">
        {/* Conteúdo principal */}
        <div className="w-full px-4 pb-4">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            className="pt-0"
          >
            {children}
          </motion.div>
        </div>

      </div>
    </LayoutProvider>
  );
};